import {
  ReflectionTopicsDrawerControlMenuItem,
  ReflectionTopicsDrawerControls,
} from './ReflectionTopicsDrawerControls';
import type {
  ReflectionTopicsDrawerControlMenuItemProps,
  ReflectionTopicsDrawerControlsProps,
} from './ReflectionTopicsDrawerControls';
import { useReflectionTopicsDrawerControl } from './useReflectionTopicsDrawerControl';

export function ReflectionTopicsDrawerControlsWrapper(
  props: Pick<ReflectionTopicsDrawerControlsProps, 'className' | 'drawerId'>,
) {
  const { helperText, isDrawerOpen, onClick, shouldShow } = useReflectionTopicsDrawerControl();
  if (!shouldShow) return null;

  return (
    <ReflectionTopicsDrawerControls {...props} isDrawerOpen={isDrawerOpen} onClick={onClick} tooltipText={helperText} />
  );
}

export function ReflectionTopicsDrawerControlMenuItemWrapper(
  props: Pick<ReflectionTopicsDrawerControlMenuItemProps, 'className' | 'drawerId'>,
) {
  const { helperText, isDrawerOpen, onClick, shouldShow } = useReflectionTopicsDrawerControl();
  if (!shouldShow) return null;

  return (
    <ReflectionTopicsDrawerControlMenuItem
      {...props}
      helperText={helperText}
      isDrawerOpen={isDrawerOpen}
      onClick={onClick}
    />
  );
}
